import { FileReference } from '@kaizenplatform/belfast-entity';
import { FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { Meta } from '@kaizenplatform/hugot-entity/dist/entity/DynamicSchemaDefinition/IDynamicSchemaSection';
import { createElement } from 'react';

import {
  DynamicSchemaDefinitionFieldType,
  DynamicSchemaDefinitionFileIds,
  DynamicSchemaDefinitionMultiLineText,
  DynamicSchemaDefinitionSelectOne,
  DynamicSchemaDefinitionSingleLineText,
} from '../../../../../graphql/generated/graphql';
import AsFileIds from './AsFileIds';
import AsMultiLineText from './AsMultiLineText';
import AsSelectOne from './AsSelectOne';
import AsSingleLineText from './AsSingleLineText';

interface Props {
  field:
    | Pick<DynamicSchemaDefinitionFileIds, 'key' | 'type'>
    | Pick<DynamicSchemaDefinitionMultiLineText, 'key' | 'type'>
    | Pick<DynamicSchemaDefinitionSelectOne, 'key' | 'type'>
    | Pick<DynamicSchemaDefinitionSingleLineText, 'key' | 'type'>;
  value: {
    values: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  };
  beforeValue?: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  files: ReadonlyArray<FileReference>;
  meta?: Meta;
  className?: string;
}

const Field = ({ field, value, beforeValue, files, meta }: Props) => {
  if (field.type == DynamicSchemaDefinitionFieldType.SelectOne && meta != null && meta.isAllowLeaveToTheCreators) {
    return <AsSelectOne field={field} value={value} beforeValue={beforeValue} />;
  }

  if (field.type == DynamicSchemaDefinitionFieldType.SingleLineText) {
    return <AsSingleLineText field={field} value={value} beforeValue={beforeValue} />;
  }

  if (field.type == DynamicSchemaDefinitionFieldType.MultiLineText) {
    return <AsMultiLineText field={field} value={value} beforeValue={beforeValue} />;
  }

  if (field.type == DynamicSchemaDefinitionFieldType.FileIds) {
    return <AsFileIds field={field} value={value} files={files} />;
  }

  return null;
};

export default Field;
